import { Fragment } from "react";

import logo from "../../img/logoredcomp.png";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import RenderProvider from "../../Context/RenderContext";

function Main() {
  
  return (
    <Fragment>
      <RenderProvider>
  
        <Body />
   
      </RenderProvider>
     
    </Fragment>
  );
}
export default Main;
